(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('RetailCtrl', retailCtrl);

    function retailCtrl($scope, $routeParams, $window, $cookies) {
        // Expire the cookie in 30 minutes
        const date = new Date();
        date.setTime(date.getTime() + 30 * 60 * 1000);

        const cookieOptions = {
            expires: date,
            secure: process.env.NODE_ENV !== 'development'
        };
        const cookieDomain = process.env.VUE_APP_STAMP_COOKIE_DOMAIN;
        if (cookieDomain && cookieDomain.trim()) {
            cookieOptions.domain = cookieDomain.trim();
        }

        try {
            $cookies.put('customily_retailuser', 'collective', cookieOptions);
        } catch (e) {
            // best-effort: if cookie write fails, continue to redirect
            console.warn('Could not set retail cookie', e);
        }

        try {
            const supplierStore = $routeParams.store;
            if (supplierStore) {
                $cookies.put('customily_supplier_store', supplierStore, cookieOptions);
            }
        } catch (e) {
            // best-effort: missing this cookie only disables automatic supplier capture
            console.warn('Could not set supplier store cookie', e);
        }

        setTimeout(function () {
            // Keep incoming query params for GTM tracking, add retail marker
            const search = window.location.search || '';
            const join = search ? `${search}&` : '?';
            $window.location.href = `https://apps.shopify.com/customily-product-personalizer${join}retail=1`;
        }, 500);
    }
})();
